<template>
  <div id="new_online_mall">
    <div>
      <h3 style="text-align: center" :style="accounttype == 2 || accounttype == 3 ? 'display:none': ''">{{ titleNameWord }}</h3>
      <div v-if="accounttype == 2 || accounttype == 3 || accounttype==5">
        <van-image
          class="custom-pic"
          :src="require('@/assets/shop/custom.png')"/>
        <div class="custom-label">{{accounttype==5?"您是万和众智财税企服平台用户":"您是定制化团购用户"}}</div>
        <div class="custom-label-next">请联系单位管理员购买（续费）或升级</div> 
      </div>
      <div v-else>
        <div class="tab-div">
          <div class="tab-nav-item">
            <van-image :src="majorVersion"/>
            <span>专业版</span>
          </div>
          <div class="font-desc">
            税收法规查询及云端工作系统
          </div>

            <div class="shop-wapper">
              <div class="shop-items">
                <div class="one-item" v-for="(good, index) in goodsLists"
                  :key="index"
                  :class="[choosedCard == index+1? 'chooed-item': '', index==0?'first-item': '']"
                  @click="clickCard(index, good)">
                  <div class="which-card">{{good.name.slice(4,6)}}</div>
                  <div style="margin: 8px 0">
                    <span class="symbol">&yen;</span>
                    <span class="yuan">{{ good.price }}</span>
                  </div>
                  <div class="which-version">专业版</div>
                   <div class="recommend-pic" v-if="index == 0">
                    <van-image width="60%" :src="recommend"/>
                  </div>
                </div>
               
              </div>
              <div class="buy-btn" @click="clickBtn(currentGoods, currentIdx)">
                <van-button>立即购买</van-button>
              </div>
          </div>
          <div class="setting-wapper">
            <div class="word">配置</div>
            <div class="tag-wapper">
              <div class="tag" v-for="(tag,i) in currentGoods.BasePackageFun"
                :key="i">
                <van-image  :src="imgs[tag.code]"></van-image>
              <span
                style="margin:5px 0px 5px 0px; color:#191A19;"
                >{{ tag.alias }}</span>
             </div>
            </div>
          </div>
        </div>
        <!-- <div
            class="shop-item"
            v-for="(good, index) in goodsLists"
            :key="good.code"
          >
            <div class="item-top">
              <div class="money">
                <div class="title">
                  <span>{{ good.name }}</span>
                  <img
                    v-if="good.name == '体验版'"
                    class="version-one"
                    src="../../../assets/index/tyb.png" />
                  <img 
                    v-else 
                    class="version-two"
                    src="../../../assets/index/zyb.png" />
                </div>
                <div>
                  <span style="font-size:13px;color:#999">{{ good.desc }}</span>
                </div>
              </div>
              <div>
                <span
                  style="font-size:14px;margin-right:4px;color:#cb4649;font-weight:bold"
                  >&yen;</span
                >
                <span class="yuan">{{ good.price.toFixed(2) }}</span>
              </div>
            </div>
            <p v-if="good.warntext" class="warn-text">{{ good.warntext }}</p>
            <van-divider style="opacity: 0.4;margin:10px 0" />
            <div class="item-center">
              <div class="word">配置:</div>
              <div class="tag">
                <van-tag
                  color="#818181"
                  plain
                  v-for="tag in good.BasePackageFun"
                  :key="tag.code"
                  style="background-color: #f7f7f7;margin:0 4px 4px 0;"
                  >{{ tag.alias }}</van-tag
                >
              </div>
            </div>


            <div class="buyBtn" v-if="good.showbuybtn || good.showupbtn">
              <div class="show">
                <van-button
                  round
                  block
                  type="info"
                  style="height: 44px;width:75%"
                  @click="clickBtn(good, index)"
                  >{{
                    good.showupbtn ? good.upbtntext : good.buybtntext
                  }}</van-button
                >
              </div>
            </div>
          </div> -->
      </div>
    </div>

    <!-- 立即购买和升级弹框 -->
    <newBuyNowPop
      :routerAgentCode="routerAgentCode"
      :buyNowItem="buyNowItem"
      :updateBuyNowItem="updateBuyNowItem"
      :buyItemProduct="buyItemProduct"
      :isConpponma="isShowCoupon"
      :billingType="billingType"
      ref="newBuyNowPop"
    ></newBuyNowPop>
  </div>
</template>

<script>
import newBuyNowPop from "../newBuyNowPop";
import { errDialog, commonDialog, warningNotify } from "@/utils/lib/toast.js";
export default {
  props: ["goodsLists", "titleNameWord", "routerAgentCode"],
  data() {
    return {
      buyNowItem: {},
      buyItemProduct: {},
      updateBuyNowItem: {},
      isShowCoupon: Boolean,
      billingType: 0, //购买产品方式：天/年
      activeType:1, //当前tab
      basicVersion:require('@/assets/shop/un_base.png'),
      majorVersion:require('@/assets/shop/major.png'),
      choosedCard: 1,
      currentGoods: [],
      currentIdx: 0,
      recommend:require('@/assets/shop/recommend.jpg'),
      imgs: {
        "000015": require('@/assets/shop/cloud.png'),
        "000001": require('@/assets/shop/nationwide.png'),
        "000002": require('@/assets/shop/local.png'),
        "000003": require('@/assets/shop/secretary.png'),
        
        "000016": require('@/assets/shop/synthesize.png'),
        "000004": require('@/assets/shop/tax.png'),
        "000017": require('@/assets/shop/specific.png'),
        "000005": require('@/assets/shop/convention.png'),

        "000006": require('@/assets/shop/trade.png'),
        "000007": require('@/assets/shop/import.png'),
        "000008": require('@/assets/shop/phone.png'),
        "000011": require('@/assets/shop/screen.png'),

        "000012": require('@/assets/shop/file.png'),
        "000013": require('@/assets/shop/select.png'),
        "000009": require('@/assets/shop/upload.png'),
        "000014": require('@/assets/shop/common.png'),

        "000010": require('@/assets/shop/yunqin.png'),
        "000018": require('@/assets/shop/accurate.png'),
        "000020": require('@/assets/shop/answer.png'),
        "000019": require('@/assets/shop/visit.png')
      }
    };
  },
  components: {
    newBuyNowPop,
  },
  computed: {
    accounttype: {
      get() {
        return this.$store.state.user.accounttype;
      },
      set() {},
    },
  },
  created () {
    if (this.routerAgentCode) {
      this.billingType = 1
      this.buyItSelf()
    }
  },
  methods: {
    changeVersion(e) {
      this.activeType = e
    },
    clickCard(e, g) {
      this.choosedCard = e+1
      this.currentIdx = e
      this.currentGoods = g
    },

    clickBtn(good, index) {
      this.choosedCard = index+1
      if(good.billingtype == '1') {
        this.billingType = 1
      } else {
        this.billingType = 2
      }

      this.isShowCoupon = good.showcoupon;
      if (good.buybtntext == "立即购买") {
        this.buyNow(good, index);
      } else if (good.buybtntext == "续费") {
        this.continueOrder(good, index);
      } else if (good.showupbtn && good.upbtntext == "升级") {
        this.upLevelBtn(good, index);
      }
    },
    // 升级
    upLevelBtn(good, index) {
      console.log(good);
      let reqBody = {
        upproductcode: good.code,
      };
      this.$http
        .reqPostProductUpgradeCalc(reqBody)
        .then((res) => {
          console.log(res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.updateBuyNowItem = res.result;
              // 打开弹框
              this.$refs.newBuyNowPop.updateNowShow = true;

              this.$refs.newBuyNowPop.isXuFei = false;
            } else {
              warningNotify(res.rltdesc, this);
            }
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("产品升级====err", err);
        });
    },
    // 自动点击购买按钮(agent存在时)
    buyItSelf () {
      this.$http
        .reqGetProductDiscount('000004')
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              console.log("自动点击购买", res);
              this.buyNowItem = res.item;
              this.$refs.newBuyNowPop.buyNowShow = true;
              this.$refs.newBuyNowPop.isXuFei = false;
            } else {
              warningNotify(res.rltdesc, this);
            }
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("自动点击购买==》", err);
        })
    },

    // 立即购买
    buyNow(good, index) {
      this.buyItemProduct = good;
      this.$http
        .reqGetProductDiscount(good.code)
        .then((res) => {
          console.log("立即购买", res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.buyNowItem = res.item;
              this.$refs.newBuyNowPop.buyNowShow = true;
              this.$refs.newBuyNowPop.isXuFei = false;
            } else {
              warningNotify(res.rltdesc, this);
            }
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("获取产品优惠列表=====》", err);
        });
    },
    // 续费
    continueOrder(good, index) {
      this.buyItemProduct = good;
      this.$http
        .reqGetProductDiscount(good.code)
        .then((res) => {
          console.log(res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.buyNowItem = res.item;
              this.$refs.newBuyNowPop.buyNowShow = true;
              this.$refs.newBuyNowPop.isXuFei = true;
            } else {
              warningNotify(res.rltdesc, this);
            }
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("获取产品优惠列表=====》", err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
#new_online_mall {
  padding: 0 12px;
  .tab-div {
    padding: 0 0 20px 0;
    .tab-nav-item {
      font-weight: bold;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 10px;
      span {
        margin-left: 5px;
      }
    }
    .active-tab-item {
      padding: 0 5px;
      background-color: #E7E7E7;
    }
    .font-desc {
      margin: 5px 0 10px 10px;
      color: #9E9E9E;
      font-size: 14px;
    }
    .shop-wapper {
      width: 100%;
      background-color: white;
      border-radius: 20px;
      padding: 20px 10px;
      .shop-items {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      .first-item {
        position: relative;
        .recommend-pic {
          position: absolute;
          left: -15px;
          top: -6px;
        }
      }
      .one-item {
        width: 30%;
        justify-content: space-between;
        display: inline-block;
        background: #fff;
        padding: 5px 5px;
        margin:0px 0px 10px 0px;
        border: 1px solid #f1f1f1;
        border-radius:15px;
        text-align: center;
        
        .which-card {
          font-size: 16px;
          color: #000000;
          margin-top: 10px;
        }
        
        .which-version {
          color: #7E8085;
        }
        .symbol {
          font-size:14px;
          margin-right:4px;
          color:#ED702E;
          font-weight:bold;
        }
        .yuan {
          font-size: 19px;
          font-weight: bold;
          color: #ED702E;
          margin-bottom: 10px 0;
        }
      }
      .chooed-item {
        border: 1px solid #E8B970;
        background-color: #F9EFDE;
        .which-card {
          color: #563300;
        }
      }
    }
    .setting-wapper {
      background-color: #fff;
      border-radius: 10px;
      margin-top: 10px;
      padding: 10px;
      .tag-wapper {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 5px 5px;
        .tag {
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
    .buy-btn {
      text-align: center;
      margin: 30px 0 0 0;
      .van-button {
        color: #51340D;
        border-radius: 50px;
        width: 90%;
        background: linear-gradient(to right,#F0D7B1, #EABD7A);
      }
      
    }
  }
  .custom-pic {
    width: 100%;
    margin-top: 25%;
    /deep/.van-image__img {
      width: 50%;
      height: 50%;
      transform: translate(50%, 50%);
    }
  }
  .custom-label {
    font-size: 16px;
    text-align: center;
    color: #969799;
    margin-top: 60px;
  }
  .custom-label-next {
    font-size: 16px;
    text-align: center;
    color: #969799;
    margin-top: 10px;
  }
  .shop-item {
    background: #fff;
    padding: 10px 10px;
    margin-bottom: 10px;
    position: relative;
    
    margin-top: 20px;
    .sell {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      // &>img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .item-top {
      height: 50px;
      display: flex;
      .item-img {
        width: 68px;
        height: 68px;
        // background-color: #;
      }
      .money {
        flex: 1;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        .title {
          font-size: 18px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          .version-one {
            margin-left: 5px;
            margin-top: 2px;
            width: 20px;
            height: 18px;
          }
          .version-two {
            margin-left: 5px;
            width: 20px;
            height: 18px;
          }
        }
      }
      .yuan {
        color: #cb4649;
        font-size: 20px;
        font-weight: bold;
      }
      .year {
        font-size: 20px;
        color: #cb4649;
        margin-right: 6px;
      }
    }
    .warn-text {
      font-size: 13px;
      color: #999;
      padding-top: 10px;
    }
    .item-center {
      display: flex;
      margin-top: 16px;
      .word {
        flex: 0 0 40px;
        padding: 2px 0 0 2px;
      }
      .tag {
        flex: 1;
        /deep/.van-tag--plain::before {
          border: 0.02667rem solid #ddd !important;
          font-size: 12px;
        }
      }
    }
    .bar {
      display: flex;
      justify-content: flex-end;
      .word {
        width: 70px;
        font-size: 12px;
      }
      .progress {
        display: flex;
        align-items: center;
      }
    }
    .buyBtn {
      margin-top: 20px;
      .show {
        display: flex;
        justify-content: center;
      }
      .notshow {
        div {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          &:before,
          &:after {
            content: "";
            display: block;
          }
        }
      }
    }
    .note {
      display: flex;
    }
  }
  .notActive {
    opacity: 0.5;
  }
}
</style>
